import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/action/paged', {
    params: toQuery(params),
  });
}

export async function queryNewAction(params) {
  return request.post('/action', {
    data: params,
  });
}

export async function generateIA({ processId, params }) {
  return request.post(`/processEngine/diagram/generate/${processId}`, {
    data: params,
  });
}

export async function queryAddConfigAction(params) {
  return request.put('/action', {
    data: params,
  });
}

export async function modifyActionConfig({ processId, versionId, token, data }) {
  return request.post(`/process/config/modify/${processId}/${versionId}?token=${token}`, {
    data: data,
  });
}

export async function queryConfigAction(params) {
  return request('/action', {
    params: toQuery(params),
  });
}
export async function queryItemConfigAction({ processId, versionId, token, id }) {
  return request(`/process/config/${processId}/${versionId}/actions/${id}?token=${token}`, {
    method: 'GET',
  });
}

export async function queryListInformation(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySaveInformation(payload) {
  return request.post(
    `/action/updateCompleteInformationFormFieldMappings/${payload.actionId}/${payload.formId}`,
    {
      data: payload.data,
    },
  );
}

export async function querySaveInformationCondition(payload) {
  return request.post(`/action/configConditions/${payload.actionId}`, {
    data: payload.data,
  });
}

export async function querySaveConfigList(payload) {
  return request.post(`/process/updateActionsDiagram/${payload.processId}`, {
    data: payload.data,
  });
}

export async function queryActionsDiagramByToken({ processId, versionId, token }) {
  return request(`/process/config/${processId}/${versionId}/diagram?token=${token}`, {
    method: 'GET',
  });
}

export async function updateActionsDiagramPositions({ processId, versionId, token, data }) {
  return request(`/process/config/${processId}/${versionId}/diagram/actions?token=${token}`, {
    method: 'PATCH',
    data: data,
  });
}

export async function updateNotesDiagramPositions({ processId, versionId, token, data }) {
  return request(`/process/config/${processId}/${versionId}/diagram/notes?token=${token}`, {
    method: 'PATCH',
    data: data,
  });
}

export async function updateNoteDiagramPosition({ processId, versionId, token, noteId, data }) {
  return request(
    `/process/config/${processId}/${versionId}/diagram/notes/${noteId}?token=${token}`,
    {
      method: 'PATCH',
      data: data,
    },
  );
}

export async function appendActionToDiagram({ processId, versionId, token, data }) {
  return request(`/process/config/append/${processId}/${versionId}?token=${token}`, {
    method: 'POST',
    data: data,
  });
}

export async function appendNoteToDiagram({ processId, versionId, token, data }) {
  return request(`/process/config/append/${processId}/${versionId}?token=${token}`, {
    method: 'POST',
    data: data,
  });
}

export async function modifyNoteDiagram({ processId, versionId, token, data }) {
  return request(`/process/config/modify/${processId}/${versionId}?token=${token}`, {
    method: 'POST',
    data: data,
  });
}

export async function setNextAction({ processId, versionId, token, actionId, data }) {
  return request(
    `/process/config/${processId}/${versionId}/actions/setNextActions/${actionId}?token=${token}`,
    {
      method: 'PATCH',
      data: data,
    },
  );
}

export async function removeActionFromDiagram({ processId, versionId, token, data }) {
  return request(`/process/config/remove/${processId}/${versionId}?token=${token}`, {
    method: 'POST',
    data: data,
  });
}

export async function removeNoteDiagram({ processId, versionId, token, data }) {
  return request(`/process/config/remove/${processId}/${versionId}?token=${token}`, {
    method: 'POST',
    data: data,
  });
}

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`${payload.url}`, {
    data: payload.data,
  });
}
